import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { env } from '../../environments/environment';
import { Broker, Inspection, Inspector, ListFilters, ListResults, Policy } from '../shared/interfaces';

@Injectable({
  providedIn: 'root',
})
export class BrokerService {
  constructor(protected http: HttpClient) {}

  public list(filters?: ListFilters) {
    return this.http.get<ListResults<Broker>>(`${env.APIUrl}/broker`, { params: filters as any });
  }

  public get(id: number) {
    return this.http.get<Broker>(`${env.APIUrl}/broker/${id}`).toPromise();
  }

  public archived(filters?: ListFilters) {
    return this.http.get<ListResults<Broker>>(`${env.APIUrl}/broker/archived`, { params: filters as any }).toPromise();
  }

  public archive(id: number) {
    return this.http.put<Broker>(`${env.APIUrl}/broker/${id}/archive`, null).toPromise();
  }

  public restore(id: number) {
    return this.http.put<Broker>(`${env.APIUrl}/broker/${id}/restore`, null).toPromise();
  }

  public remove(id: number) {
    return this.http.delete<Broker>(`${env.APIUrl}/broker/${id}`).toPromise();
  }

  public edit(id: number, broker: Broker) {
    return this.http.put<Broker>(`${env.APIUrl}/broker/${id}`, broker).toPromise();
  }

  public create(broker: Broker) {
    return this.http.post<Broker>(`${env.APIUrl}/broker`, broker).toPromise();
  }

  public inspectors(brokerId: number, search = '') {
    return this.http.get<Inspector[]>(`${env.APIUrl}/broker/${brokerId}/inspectors`, { params: { search } });
  }

  public policies(brokerId: number) {
    return this.http.get<Policy[]>(`${env.APIUrl}/broker/${brokerId}/policies`);
  }

  public inspections(brokerId: number) {
    return this.http.get<Inspection[]>(`${env.APIUrl}/broker/${brokerId}/inspections`);
  }

  public count() {
    return this.http.get<{ active: boolean; count: number }[]>(`${env.APIUrl}/broker/count`).toPromise();
  }
}
